/**
 * Touch-Eingabe: Swipe-Erkennung für den Transform-Modus
 * bzw. Blockieren nativer Gesten, wenn Touch deaktiviert ist.
 */

const SWIPE_DISTANCE = 50;
const SWIPE_VELOCITY = 0.35;

export class TouchHandler {
	/**
	 * @param {Element} target Element, auf dem gelauscht wird.
	 * @param {Object}  cb     Callbacks/Optionen:
	 *   axis             'v' | 'h' (Navigationsachse, Standard 'v')
	 *   verdict()        → 'native' | 'block' | 'navigate'
	 *   isLocked()       → bool
	 *   onNavigate(dir)  → void
	 */
	constructor( target, cb ) {
		this.target = target;
		this.cb = cb;
		this.axis = cb.axis === 'h' ? 'h' : 'v';
		this.tracking = false;
		this.startX = 0;
		this.startY = 0;
		this.startTime = 0;

		this.onStart = this.onStart.bind( this );
		this.onMove = this.onMove.bind( this );
		this.onEnd = this.onEnd.bind( this );

		target.addEventListener( 'touchstart', this.onStart, { passive: true } );
		target.addEventListener( 'touchmove', this.onMove, { passive: false } );
		target.addEventListener( 'touchend', this.onEnd, { passive: true } );
	}

	onStart( event ) {
		const touch = event.touches[ 0 ];
		this.tracking = true;
		this.startX = touch.clientX;
		this.startY = touch.clientY;
		this.startTime = performance.now();
	}

	onMove( event ) {
		// Innerhalb horizontaler Slider scrollt der Browser nativ (Snap X).
		if ( event.target instanceof Element && event.target.closest( '.sfps-horizontal' ) ) {
			return;
		}

		const verdict = this.cb.verdict();

		if ( verdict === 'native' ) {
			return;
		}

		// 'block' und 'navigate' unterbinden das native Scrollen; bei
		// 'navigate' übernimmt die Swipe-Auswertung in onEnd.
		if ( event.cancelable ) {
			event.preventDefault();
		}
	}

	onEnd( event ) {
		if ( ! this.tracking ) {
			return;
		}

		this.tracking = false;

		if ( this.cb.verdict() !== 'navigate' || this.cb.isLocked() ) {
			return;
		}

		// Innerhalb des Sliders scrollt der Browser horizontal (onMove greift
		// nicht ein); auf der Navigationsachse dominante Swipes navigieren.
		const touch = event.changedTouches[ 0 ];
		const deltaY = this.startY - touch.clientY;
		const deltaX = this.startX - touch.clientX;
		const elapsed = Math.max( 1, performance.now() - this.startTime );

		const main = this.axis === 'h' ? deltaX : deltaY;
		const cross = this.axis === 'h' ? deltaY : deltaX;

		// Wischer quer zur Navigationsachse ignorieren.
		if ( Math.abs( cross ) > Math.abs( main ) ) {
			return;
		}

		const velocity = Math.abs( main ) / elapsed;

		if ( Math.abs( main ) > SWIPE_DISTANCE || velocity > SWIPE_VELOCITY ) {
			this.cb.onNavigate( main > 0 ? 1 : -1 );
		}
	}

	destroy() {
		this.target.removeEventListener( 'touchstart', this.onStart );
		this.target.removeEventListener( 'touchmove', this.onMove );
		this.target.removeEventListener( 'touchend', this.onEnd );
	}
}
